import React, { useState, useCallback } from 'react'
import { Input, CheckBox } from '../../Form/Form'
import Button from 'react-bootstrap/Button'
import Box from './Styled/Box'
import Controllers from '../../../Api/Controllers'
import Helpers from '../../Helpers/Helpers'
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom'

const Login = () => {

  const { type } = useParams()

  const isLoginCustomers = type === 'clientes'

  const [session, setSession] = useState({
    username: Helpers.config.isDeveloperWeb() ? (isLoginCustomers ? '1' : 'administrador') : '',
    password: Helpers.config.isDeveloperWeb() ? '1234' : '',
  })

  const dataSubmit = useCallback(() => {
    return { 
      p_username: session.username,
      p_password: session.password,
      p_type: isLoginCustomers ? 1 : 2
    }
  }, [session, isLoginCustomers])

  const handleSubmit = e => {
    e.preventDefault()
    let $this = e.target

    if (!$this.checkValidity()) {
      $this.classList.add('was-validated')
    } else {
      $this.classList.remove('was-validated')

      let button = $this.querySelector('button');
      let buttonHTML = button.innerHTML;
      button.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
      
      Controllers.users.get_login(dataSubmit()).then(res => {
        Helpers.toast.construct({ ...res, toast });
        if (res.response === 'success') {
          Helpers.localStorage.setSession({
            jwt: res.data.jwt
          });
          window.location.href = Helpers.config.convertUrl({ url: '/' });
        } else {
          button.innerHTML = buttonHTML;
        }
      }).catch(req => {
        Helpers.promise.catch({req, toast });
        button.innerHTML = buttonHTML;
      });
    }
  }

  const Logo = Helpers.config.resourcesUrl({ url: '/images/dashboard/logo.png' })

  return (
    <Box>
      <Box.Brand>
        <Box.BrandTop>
          <Box.Logo src={Logo} alt="Botnatura" />
        </Box.BrandTop>
        <Box.BrandCopy>
          <h1>Para sentirse bien</h1>
          <p>
            Accede a tu panel para gestionar ventas, red, inventario y reportes en un solo lugar.
          </p>
        </Box.BrandCopy>
        <Box.BrandFooter>
          Botnatura · Acceso seguro
        </Box.BrandFooter>
      </Box.Brand>

      <Box.Panel>
        <Box.Container>
          <Box.Content>
            <Box.Badge>
              <i className="fa fa-shield-alt" aria-hidden="true"></i>
              {isLoginCustomers ? 'Consultores' : 'Administrativos'}
            </Box.Badge>
            <Box.Title>Iniciar sesión</Box.Title>
            <Box.Hint>
              Ingresa tus credenciales para continuar.
            </Box.Hint>

            <form onSubmit={handleSubmit} autoComplete="off" className="needs-validation" noValidate>
              <div className="form-row">
                <Input
                  placeholder="Nombre de usuario"
                  icon="fa fa-user"
                  classNameParent="col-12 mb-3"
                  required
                  defaultValue={session.username}
                  onChange={e => setSession({ ...session, username: e.currentTarget.value })}
                  size=""
                />
                <Input
                  type="password"
                  placeholder="Contraseña"
                  icon="fa fa-lock"
                  classNameParent="col-12 mb-2"
                  required
                  defaultValue={session.password}
                  onChange={e => setSession({ ...session, password: e.currentTarget.value })}
                  size=""
                />
                <CheckBox
                  text="Recordarme"
                  defaultChecked={false}
                  classNameParent="col-12"
                  id="remember_me"
                />
                <div className="col-12 mt-4">
                  <Button type="submit" variant="primary" block className="btn-login">
                    INGRESAR
                  </Button>
                </div>
              </div>
            </form>
          </Box.Content>
        </Box.Container>
      </Box.Panel>
    </Box>
  )
}

export default Login
